module.exports = __webpack_public_path__ + "static/media/OpenQuestion.30bd0bf6.svg";